import { useQuery } from "@tanstack/react-query";

import FetchError from "@/components/ui/fetch-error";
import Loading from "@/components/ui/loading";
import { Table } from "react-bootstrap";

import api from "@/lib/api";

type ItemModalData = {
  title: string;
  description: string;
  text: string;
  item_type_title: string;
  answer_type_title: string;
  answer: string;
  module_title: string;
  survey_title: string;
  second_language: {
    language_title: string;
    description: string;
    text: string;
    answer: string;
  } | null;
};

export default function QuestionaireSearchItemModal({ itemId }: { itemId: number }) {
  const { data, error, isPending } = useQuery<ItemModalData>({
    queryKey: ["srv-quesionniare-search-modal", itemId],
    queryFn: () => api.get<ItemModalData>(`/srv/search/item/${itemId}`),
    enabled: !!itemId,
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  return (
    <>
      <p>
        <span className="fw-semibold">{data.survey_title}</span>
        <span className="g2-text-grey" style={{ fontSize: "0.8rem" }}>
          {" "}
          &gt;{" "}
        </span>
        <span className="fw-semibold">{data.module_title}</span>
        <span className="g2-text-grey" style={{ fontSize: "0.8rem" }}>
          {" "}
          &gt;{" "}
        </span>
        <span className="g2-text-grey ">{data.title}</span>
      </p>
      <Table bordered striped responsive width="100%">
        <tbody>
          <tr>
            <td className="fw-semibold" style={{ width: "25%" }}>
              Description:
            </td>

            {data.second_language != null ? (
              <td>
                <span>{data.description}</span>
                <span className="text-muted ms-2">({data.second_language.description})</span>
              </td>
            ) : (
              <td>{data.description}</td>
            )}
          </tr>
          <tr>
            <td className="fw-semibold" style={{ width: "25%" }}>
              Item type:
            </td>
            <td>{data.item_type_title}</td>
          </tr>
          <tr>
            <td className="fw-semibold" style={{ width: "25%" }}>
              Question text:
            </td>
            {data.second_language ? (
              <td>
                <span>{data.text}</span>
                <span className="text-muted ms-2">({data.second_language.text})</span>
              </td>
            ) : (
              <td>{data.text}</td>
            )}
          </tr>
          <tr>
            <td className="fw-semibold" style={{ width: "25%" }}>
              Answer type:
            </td>
            <td>{data.answer_type_title}</td>
          </tr>
          <tr>
            <td className="fw-semibold" style={{ width: "25%" }}>
              Answer choices:
            </td>
            {data.second_language ? (
              <td>
                <span>{data.answer}</span>
                <span className="text-muted ms-2">({data.second_language.answer})</span>
              </td>
            ) : (
              <td>{data.answer}</td>
            )}
          </tr>
        </tbody>
      </Table>
    </>
  );
}
